var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{attrs:{"items":_vm.items,"divider":">"},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.$emit('click', item)}}},[_c('span',{staticClass:"tgk-paragraph-text"},[_vm._v(_vm._s(item.title))])])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }